<template>
  <div class="all">
    <SideControls />
    <div class="visualizers" v-if="emails && emails.length">
      <div>All Emails</div>
      <input
        type="text"
        class="search"
        v-model="search"
        placeholder="Search Emails..."
      />
      <div
        v-for="(email, index) in filteredEmails"
        :key="index"
        class="visualizerLink"
      >
        <span> {{ index }} </span>
        <router-link :to="`/emails/${email._id}`">{{
          email.title ? email.title : email._id
        }}</router-link>
      </div>
      <button class="action" @click="createNewEmail">+ New Email</button>
    </div>
  </div>
</template>

<script>
import { getAllEmails, createNewEmail } from "./EmailHelpers";
import SideControls from "../../components/SideControls";

export default {
  name: "AllEmails",
  async created() {
    this.emails = await getAllEmails();
  },
  data() {
    return {
      emails: null,
      search: "",
    };
  },
  computed: {
    filteredEmails() {
      return this.emails.filter((email) => {
        if (email.title) {
          return email.title.toLowerCase().includes(this.search.toLowerCase());
        } else {
          return email._id;
        }
      });
    },
  },
  components: {
    SideControls,
  },
  methods: {
    async createNewEmail() {
      const emailId = await createNewEmail();
      this.$router.push(`/emails/${emailId}`);
    },
  },
};
</script>

<style scoped>
.all {
  display: flex;
  position: relative;
  height: calc(100vh - 36px);
}
.visualizers {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 450px;
}
.visualizerLink {
  padding: 5px;
  background-color: #f7f7f7;
  margin-bottom: 5px;
  margin-top: 5px;
}

.action {
  cursor: pointer;
  margin-top: 10px;
}
.search {
  margin-bottom: 10px;
  margin-top: 5px;
}
</style>